import HomePage from 'components/HomePage'
import { getHomePage, getSettings } from 'lib/sanity.client'

export default function Index({ home, settings }) {
  return <HomePage {...home} settings={settings} />
}

export async function getStaticProps() {
  const [settings, home] = await Promise.all([getSettings(), getHomePage()])

  return {
    props: {
      settings,
      home,
    },
    revalidate: 14400,
  }
}
